// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"DataLoader_loaderContainer__2MVeK","loader":"DataLoader_loader__1UvN7","spin":"DataLoader_spin__22-Dq"};